module.exports = __webpack_public_path__ + "img/zhuti.4b2297d5.png";